// src/stores/useFiltersStore.ts
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type DateRangeKey = "LAST_MONTH" | "LAST_QUARTER" | "LAST_HALF_YEAR";

export type StateItem = { id: string; label: string };
export type CityItem = { id: string; label: string };
export type CategoryItem = { id: string; label: string };

type FiltersState = {
  selectedState: StateItem | null;        // default set after states load (if no URL filters)
  selectedCity: CityItem | null;          // default All Cities (local sentinel)
  selectedCategory: CategoryItem | null;
  selectedDateRange: DateRangeKey;
  setState: (v: StateItem | null) => void;
  setCity: (v: CityItem | null) => void;
  setCategory: (v: CategoryItem | null) => void;
  setDateRange: (v: DateRangeKey) => void;
  reset: () => void;
};

export const ALL_CITY: CityItem = { id: "ALL", label: "All Cities" };
export const ALL_CATEGORY: CategoryItem = { id: "ALL", label: "All Categories" };

export const useFiltersStore = create<FiltersState>()(
  devtools((set) => ({
    selectedState: null,
    selectedCity: ALL_CITY,
    selectedCategory: ALL_CATEGORY,
    selectedDateRange: "LAST_QUARTER",
    setState: (v) => set({ selectedState: v, selectedCity: ALL_CITY }),
    setCity: (v) => set({ selectedCity: v }),
    setCategory: (v) => set({ selectedCategory: ALL_CATEGORY.id === v?.id ? ALL_CATEGORY : v }),
    setDateRange: (v) => set({ selectedDateRange: v }),
    reset: () =>
      set({
        selectedCity: ALL_CITY,
        selectedCategory: null,
        selectedDateRange: "LAST_QUARTER",
      }),
  }))
);
